import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";

import { Keyword,
         SearchFormService } from "../internal";

import { KeywordDataType } from "../../shared";

@Component({
    selector: "obpa-search-form-keyword",
    templateUrl: "./search-form-keyword.component.html"
})
export class SearchFormKeywordComponent {
    constructor(public searchForm: SearchFormService) {}

    @Input()
    keyword: Keyword;

    @Input()
    keywordFormControl: FormControl;

    get keywordSimpleType(): string {
        if (this.keyword.dataset) {
            return "Dataset";
        } else if (this.keyword.mask) {
            return "Mask";
        } else {
            switch (this.keyword.type) {
                case KeywordDataType.SmallNumeric:
                    return "SmallNumeric";
                case KeywordDataType.LargeNumeric:
                    return "LargeNumeric";
                case KeywordDataType.Date:
                case KeywordDataType.DateTime:
                    return "Date";
                case KeywordDataType.Currency:
                case KeywordDataType.SpecificCurrency:
                    return "Currency";
                case KeywordDataType.Float:
                    return "Float";
                case KeywordDataType.AlphaNumeric:
                case KeywordDataType.AlphaNumericSingleTable:
                case KeywordDataType.AlphaNumericCSInsensitiveSearch:
                case KeywordDataType.AlphaNumericSingleTableCSInsensitiveSearch:
                // use the generic input
                case KeywordDataType.Null:
                default:
                    return "AlphaNumeric";
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/search-panel/components/search-form-keyword.component.ts